"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRateSheetDetail = void 0;
const openapi_1 = require("../../../openapi");
const IRateSummary_1 = require("../rates/IRateSummary");
class IRateSheetDetail {
    id;
    orgKey;
    name;
    description;
    assignedCustomers;
    rateCount;
    shipping;
    receiving;
    returns;
    adjustments;
    assemblies;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IRateSheetDetail.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IRateSheetDetail.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IRateSheetDetail.prototype, "name", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IRateSheetDetail.prototype, "description", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IRateSheetDetail.prototype, "assignedCustomers", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IRateSheetDetail.prototype, "rateCount", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IRateSummary_1.IRateSummary) })
], IRateSheetDetail.prototype, "shipping", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IRateSummary_1.IRateSummary) })
], IRateSheetDetail.prototype, "receiving", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IRateSummary_1.IRateSummary) })
], IRateSheetDetail.prototype, "returns", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IRateSummary_1.IRateSummary) })
], IRateSheetDetail.prototype, "adjustments", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IRateSummary_1.IRateSummary) })
], IRateSheetDetail.prototype, "assemblies", void 0);
exports.IRateSheetDetail = IRateSheetDetail;
